import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../views/MainPages/LoginPage.vue";
import LandingPage from "../views/MainPages/LandingPage.vue";
import DashboardPage from "../views/ChildPages/DashboardPage.vue";
import PollsPage from "../views/ChildPages/PollsPage.vue";
import AdminsPage from "../views/ChildPages/AdminsPage.vue";
import RequestToPollPage from "../views/ChildPages/RequestToPollPage.vue";
import FlaggedPollsPage from "../views/ChildPages/FlaggedPollsPage.vue";
import CuratorRequestsPage from "../views/ChildPages/CuratorRequestsPage.vue";
import { isUserAuthenticated } from "../utils/auth";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    name: "Landing",
    component: LandingPage,
    redirect: "/dashboard", // Default child route
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Dashboards",
        component: DashboardPage,
        meta: { requiresAuth: true },
      },
      {
        path: "polls",
        name: "Manage Polls",
        component: PollsPage,
        meta: { requiresAuth: true },
      },
      {
        path: "curators",
        name: "Manage Curators",
        component: AdminsPage,
        meta: { requiresAuth: true },
      },
      {
        path: "requests",
        name: "Poll Requests",
        component: RequestToPollPage,
        meta: { requiresAuth: true },
      },
      {
        path: "flagged",
        name: "Flagged Polls",
        component: FlaggedPollsPage,
        meta: { requiresAuth: true },
      },
      {
        path: "curatorRequests",
        name: "Curator Requests",
        component: CuratorRequestsPage,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Authentication guard
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = await isUserAuthenticated();

  if (requiresAuth && !isAuthenticated) {
    // Redirect to login if route requires auth and user is not authenticated
    next("/login");
  } else if (to.path === "/login" && isAuthenticated) {
    // Redirect to dashboard if user is already logged in and tries to access login
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
